import { makeImmutable } from "../../core";
import { UninitializedParameterScope } from "./UninitializedParameterScope";
export class ParameterScope {
    constructor(params) {
        this.parameterSet = params.parameterSet;
        this.now = params.now;
        this.fulfillmentTime = params.fulfillmentTime;
        makeImmutable(this);
    }
    static fromParameterSet(parameterSet, now) {
        return new ParameterScope({
            parameterSet,
            now,
            fulfillmentTime: null,
        });
    }
}
ParameterScope.Uninitialized = new UninitializedParameterScope();
